import { API } from '../common/api';
import { ESTIMATE_URL } from '../common/env';

export const calculateCarbonEstimate = async (estimate: { data: any }, country: string) => {
  const estimatesResponse = await API.put(`${ESTIMATE_URL}/estimate-service/calculator/calculate-all`, {
    scenarios: estimate.data,
    country: country === 'br' ? 'BR' : 'US',
  });
  return estimatesResponse.data;
};
